module.exports = __webpack_public_path__ + "img/noSearch-icon.b119c302.png";